import { cn } from '@repo/tailwind-config/tailwind.functions'
import { TailwindColor, tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Typography from '@repo/ui/typography'
import { ReactNode } from 'react'

type Props = {
  label: string | ReactNode
  data: string | ReactNode
  dataTextColor?: TailwindColor
  display?: 'row' | 'column'
  className?: string
}

const LabelWithText = ({ label, data, className, dataTextColor, display = 'column' }: Props) => {
  return (
    <div
      className={cn(
        'flex',
        { 'flex-col': display === 'column', 'items-center justify-between': display === 'row' },
        className
      )}
    >
      <Typography variant="label-medium" color={tailwindColors.grey.lighter}>
        {label}
      </Typography>
      <div className="h-1" />
      {typeof data === 'string' ? (
        <Typography variant="tag" color={dataTextColor ?? tailwindColors.black.DEFAULT}>
          {data}
        </Typography>
      ) : (
        data
      )}
    </div>
  )
}

export default LabelWithText
